
import { useContext, useEffect, useState } from 'react';
import { VerifiedPhoneContext } from '../../utils/verifiedPhoneContext';
import { VapiWidget } from '@vapi-ai/client-sdk-react';
import "./ChatBot.scss";

const ChatBot = ({ language }) => {

  const [config, setConfig] = useState(null);
  const phoneContext = useContext(VerifiedPhoneContext);
  const verifiedPhone = phoneContext?.phone || null;

  useEffect(() => {
    const phoneNumber = verifiedPhone || "";
    const FirstName = localStorage.getItem("session_user_firstname");

    const session_enChatPlaceholder = localStorage.getItem("session_enChatPlaceholder");
    const session_enEmptyChatMessage = localStorage.getItem("session_enEmptyChatMessage");
    const session_enMainLabel = localStorage.getItem("session_enMainLabel");
    const session_deChatPlaceholder = "Schreibe hier deine Nachricht …";
    const session_deEmptyChatMessage = localStorage.getItem("session_deEmptyChatMessage");
    const session_deMainLabel = localStorage.getItem("session_deMainLabel");

    // Accept stored national and international phone formats without changing the number.
    const isValidPhoneNumber = /^\+?\d{9,15}$/.test(phoneNumber);

    if (isValidPhoneNumber) {
      setConfig({
        assistantOverrides: {
          variableValues: {
            phoneNumber,
            FirstName,
            name: FirstName || "",
          },
        },
        publicKey: "8e100f85-ab6b-48f5-82df-6b811ed320fc",
        assistantId: language === "en" ? "cd5b08a2-16ae-482d-8be3-eaf5dc5f9fac" : "e469abb5-69e5-4b6f-b4fe-413b6fd29a55",
        mode: "chat",
        theme: "dark",
        size: "compact",
        position: "bottom-right",
        mainLabel: language === "en" ? session_enMainLabel : session_deMainLabel,
        emptyChatMessage: language === "en" ? session_enEmptyChatMessage : session_deEmptyChatMessage,
        chatPlaceholder: language === "en" ? session_enChatPlaceholder : session_deChatPlaceholder,
      });
    } else {
      setConfig(null);
    }
  }, [language, verifiedPhone]);

  const configMatchesPhone = config?.assistantOverrides?.variableValues?.phoneNumber === verifiedPhone;
  const configMatchesLanguage = config?.assistantId === (language === "en" ? "cd5b08a2-16ae-482d-8be3-eaf5dc5f9fac" : "e469abb5-69e5-4b6f-b4fe-413b6fd29a55");
  if (!phoneContext || (verifiedPhone && (!configMatchesPhone || !configMatchesLanguage))) return <p role="status">{language === "en" ? "Loading chat..." : "Chat wird geladen..."}</p>;
  return config && verifiedPhone && configMatchesPhone && configMatchesLanguage ? <VapiWidget key={`${language}:${verifiedPhone}`} {...config} /> : <p role="alert">{language === "en" ? "The chat needs a valid phone number in your profile. Please ask reception to check your details." : "Der Chat benötigt eine gültige Telefonnummer in deinem Profil. Bitte lasse deine Angaben am Empfang prüfen."}</p>;
}

export default ChatBot;